import { render, staticRenderFns } from "./ConfigurationModal.vue?vue&type=template&id=365ca5c4&"
import script from "./ConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./ConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365ca5c4')) {
      api.createRecord('365ca5c4', component.options)
    } else {
      api.reload('365ca5c4', component.options)
    }
    module.hot.accept("./ConfigurationModal.vue?vue&type=template&id=365ca5c4&", function () {
      api.rerender('365ca5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Accounts/Modals/ConfigurationModal.vue"
export default component.exports